import script from "./SpvDeals.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvDeals.vue?vue&type=script&setup=true&lang=js"

import "./SpvDeals.vue?vue&type=style&index=0&id=9f7cbc46&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f7cbc46"]])

export default __exports__